export default __webpack_public_path__ + "static/media/Arch_AWS-Lambda_64.8dbe12b1.svg";